import ha0 from '../img/hard/0.jpg';
import ha1 from '../img/hard/1.jpg';
import ha2 from '../img/hard/2.jpg';
import ha3 from '../img/hard/3.jpg';
import ha4 from '../img/hard/4.jpg';
import ha5 from '../img/hard/5.jpg';
import ha6 from '../img/hard/6.jpg';
import ha7 from '../img/hard/7.jpg';
import ha8 from '../img/hard/8.jpg';
import ha9 from '../img/hard/9.jpg';
import ha10 from '../img/hard/10.jpg';
import ha11 from '../img/hard/11.jpg';
import ha12 from '../img/hard/12.jpg';
import ha13 from '../img/hard/13.jpg';
import ha14 from '../img/hard/14.jpg';
import ha15 from '../img/hard/15.jpg';
import ha16 from '../img/hard/16.jpg';
import ha17 from '../img/hard/17.jpg';
import ha18 from '../img/hard/18.jpg';
import ha19 from '../img/hard/19.jpg';
import ha20 from '../img/hard/20.jpg';
import ha21 from '../img/hard/21.jpg';
import ha22 from '../img/hard/22.jpg';
import ha23 from '../img/hard/23.jpg';
import ha24 from '../img/hard/24.jpg';
import uniqid from 'uniqid';

const hardLevelImages = [
  {
    img: ha0,
    alt: 'The Incredible Hulk',
    id: uniqid(),
  },
  {
    img: ha1,
    alt: 'Iron Man 2',
    id: uniqid(),
  },
  {
    img: ha2,
    alt: 'Iron Man',
    id: uniqid(),
  },
  {
    img: ha3,
    alt: 'Iron Man 3',
    id: uniqid(),
  },
  {
    img: ha4,
    alt: 'Thor: the dark World',
    id: uniqid(),
  },
  {
    img: ha5,
    alt: 'Thor: Ragnarok',
    id: uniqid(),
  },
  {
    img: ha6,
    alt: 'Thor',
    id: uniqid(),
  },
  {
    img: ha7,
    alt: 'Captain America: The First Avenger',
    id: uniqid(),
  },
  {
    img: ha8,
    alt: 'Captain America: The Winter Soldier',
    id: uniqid(),
  },
  {
    img: ha9,
    alt: 'Captain America: Civil War',
    id: uniqid(),
  },
  {
    img: ha10,
    alt: 'Captain Marvel',
    id: uniqid(),
  },
  {
    img: ha11,
    alt: 'The Avengers',
    id: uniqid(),
  },
  {
    img: ha12,
    alt: 'Avengers: Endgame',
    id: uniqid(),
  },
  {
    img: ha13,
    alt: 'Avengers: Age of Ultron',
    id: uniqid(),
  },
  {
    img: ha14,
    alt: 'Avengers: Infinity War',
    id: uniqid(),
  },
  {
    img: ha15,
    alt: 'Guardians of the Galaxy Vol. 2',
    id: uniqid(),
  },
  {
    img: ha16,
    alt: 'Guardians of the Galaxy',
    id: uniqid(),
  },
  {
    img: ha17,
    alt: 'Ant-Man and The Wasp',
    id: uniqid(),
  },
  {
    img: ha18,
    alt: 'Ant-Man',
    id: uniqid(),
  },
  {
    img: ha19,
    alt: 'Doctor Strange',
    id: uniqid(),
  },
  {
    img: ha20,
    alt: 'Doctor Strange in the Multiverse of Madness',
    id: uniqid(),
  },
  {
    img: ha21,
    alt: 'Black Panther',
    id: uniqid(),
  },
  {
    img: ha22,
    alt: 'Black Widow',
    id: uniqid(),
  },
  {
    img: ha23,
    alt: 'Shang-Chi and The Legend of The Ten Rings',
    id: uniqid(),
  },
  {
    img: ha24,
    alt: 'Eternals',
    id: uniqid(),
  },
];

export default hardLevelImages;
